<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 09 18 / ODOO-… (заказ Игоря: именованные стили): вкладка «Styles» отчёта / списка — статистика стилей,
             которыми оформлены загруженные строки (именованные стили сегмента CSS-CLASS, классы фронта, безымянные inline), и
             отбор: отмеченные стили фильтруют строки грида (чипс поиска «Styles: …» — как поиск, но по стилю). Считает сам
             грид вкладки данных (AttrGrid.styleStats_compute — те же каналы, что красит formatItem), здесь только показ -->
        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
        <div class="attr-style-stats" ref="attr_container">
            <div class="ass-bar">
                <button type="button" class="ass-btn" @click="compute()" :disabled="busy" :title="t('Count the styles again')"><i class="pi pi-refresh"></i><span>{{ t('Refresh') }}</span></button>
                <button type="button" class="ass-btn" @click="clearFilter()" :disabled="!selected.length" :title="t('Remove the filter by styles')"><i class="pi pi-filter-slash"></i><span>{{ t('Clear filter') }}</span></button>
                <button type="button" class="ass-btn" @click="showGrid()" :disabled="!grid" :title="t('Switch to the data tab')"><i class="pi pi-table"></i><span>{{ t('Show in the grid') }}</span></button>
                <span class="ass-info" v-if="busy">{{ t('Counting… {pct}%', { pct: progress }) }}</span>
                <span class="ass-info" v-else-if="grid">{{ tn(rows.length, '{n} style', '{n} styles') }} · {{ tn(info.rows, '{n} row', '{n} rows') }} · {{ tn(info.cols, '{n} column', '{n} columns') }}<template v-if="selected.length"> · {{ t('filter: {n}', { n: selected.length }) }}</template></span>
                <span class="ass-info" v-else>{{ t('Open the data tab first — the styles are counted over its rows') }}</span>
            </div>
            <div class="ass-empty" v-if="!busy && grid && !rows.length">{{ t('No styles are applied to the loaded rows') }}</div>
            <div class="ass-scroll" v-else>
                <table class="ass-table">
                    <thead>
                        <tr>
                            <th class="ass-c-check"></th>
                            <th class="ass-c-sample">{{ t('Sample') }}</th>
                            <th class="ass-c-title">{{ t('Style') }}</th>
                            <th class="ass-c-num" :title="t('Rows that carry the style (on the row or on any of its cells)')">{{ t('Rows') }}</th>
                            <th class="ass-c-num" :title="t('Cells styled by cell rules (a whole-row style is counted in Rows)')">{{ t('Cells') }}</th>
                            <th class="ass-c-num" :title="t('Columns with this style set in the column definition')">{{ t('Columns') }}</th>
                            <th class="ass-c-rules" :title="t('Formatting rules of this widget that refer to the style')">{{ t('Rules') }}</th>
                        </tr>
                    </thead>
                    <tbody v-for="g in groups" :key="g.key">
                        <tr class="ass-group"><td colspan="7">{{ g.title }}<span class="ass-group-n">{{ g.items.length }}</span></td></tr>
                        <tr v-for="it in g.items" :key="it.key" class="ass-row" :class="{ 'is-on': isOn(it.key), 'is-static': !it.filterable }"
                            @click="toggle(it, $event)" :title="it.filterable ? t('Click — add to / remove from the filter; Alt + click — only this style') : t('A column style: it does not depend on the data, there is nothing to filter')">
                            <td class="ass-c-check"><span class="ass-check" :class="{ 'is-on': isOn(it.key), 'is-off': !it.filterable }"><i v-if="isOn(it.key)" class="pi pi-check"></i></span></td>
                            <td class="ass-c-sample"><span class="ass-sample" :style="it.css">Aa 123</span></td>
                            <td class="ass-c-title">
                                <span class="ass-title">{{ it.title }}</span>
                                <span class="ass-name" v-if="it.name && it.name !== it.title">{{ it.name }}</span>
                                <i v-if="it.recordId" class="pi pi-external-link ass-open" :title="t('Open the style element')" @click.stop="openStyle(it)"></i>
                            </td>
                            <td class="ass-c-num">{{ fmt(it.rows) }}<span class="ass-rowlevel" v-if="it.rowLevel" :title="t('Rows styled as a whole')">▤ {{ fmt(it.rowLevel) }}</span></td>
                            <td class="ass-c-num">{{ fmt(it.cells) }}</td>
                            <td class="ass-c-num">{{ fmt(it.cols) }}</td>
                            <td class="ass-c-rules" :title="it.rules.join('\n')"><span v-if="it.rules.length" class="ass-rules-n">{{ it.rules.length }}</span>{{ it.rules.slice(0, 2).join(' · ') }}<template v-if="it.rules.length > 2"> …</template></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'

export default {
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({
        WIDGET: {},
        attr: {},
        rows: [],
        info: { rows: 0, cols: 0 },
        selected: [],
        busy: false,
        progress: 0,
        tick: 0,
    }),
    setup() {
        const store = useMainStore()
        return { store }
    },
    computed: {
        grid() {
            this.tick   // грид монтируется позже вкладки — пересчёт по tick
            const list = Object.values(this.WIDGET?.applys_CHIPS || {}).filter(g => g && g.flex && typeof g.styleStats_compute === 'function')
            return list.find(g => g.attr?.name === 'dataSheet') || list.find(g => g.attr?.isRecords) || list[0] || null
        },
        groups() {
            const order = ['Stock category', 'Grade', 'Alert', 'Status', 'Horizon', 'Report band']
            const by = new Map()
            for (const it of this.rows) { if (!by.has(it.group)) by.set(it.group, []); by.get(it.group).push(it) }
            const rank = (g) => { const i = order.indexOf(g); return g === 'Unnamed (inline style)' ? 900 : (g === 'Other classes' ? 800 : (i >= 0 ? i : 100)) }
            // IE 2026 09 23 / ODOO-341407: i18n: группы кода — по английскому ключу (сравнения выше), показ — через словарь; группы бэка (info.group) — как пришли
            const groupTitle = (g) => g === 'Unnamed (inline style)' ? this.t('Unnamed (inline style)') : (g === 'Other classes' ? this.t('Other classes') : g)
            return [...by.entries()].sort((a, b) => rank(a[0]) - rank(b[0]) || a[0].localeCompare(b[0]))
                .map(([key, items]) => ({ key, title: groupTitle(key), items: items.sort((a, b) => (b.rows + b.cols) - (a.rows + a.cols) || a.title.localeCompare(b.title)) }))
        },
    },
    created() {
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    mounted() {
        this.store.cssClasses_loadAll()
        // вкладка снова на виду (ширина из 0 стала ненулевой) — пересчитать: данные и отбор могли смениться
        // пересчёт — в следующем кадре: менять разметку прямо в колбэке ResizeObserver нельзя («ResizeObserver loop completed
        // with undelivered notifications», как у AttrCompare)
        this._ro = new ResizeObserver(() => {
            if (this._roRaf) return
            this._roRaf = requestAnimationFrame(() => {
                this._roRaf = 0
                if (this._dead) return
                const w = this.$refs.attr_container?.offsetWidth || 0
                if (w && !this._wasVisible) this.compute()
                this._wasVisible = !!w
            })
        })
        if (this.$refs.attr_container) this._ro.observe(this.$refs.attr_container)
    },
    unmounted() {
        this._ro?.disconnect()
        if (this._roRaf) cancelAnimationFrame(this._roRaf)
        this._dead = true
    },
    watch: {
        'store.cssClasses_change_index'() { if (this.rows.length) this.decorate(this._raw || []) },
        'WIDGET.loading'(v) { if (!v && this.$refs.attr_container?.offsetWidth) this.$nextTick(() => this.compute()) },
    },
    methods: {
        content_Changed() {
            this.store.widget_attr_set(this)
        },
        fmt(n) { return n ? Number(n).toLocaleString('en-US').replace(/,/g, ' ') : '' },
        isOn(key) { return this.selected.includes(key) },
        compute() {
            this.tick++
            const g = this.grid
            if (!g || this.busy) { if (!g) { this.rows = []; this.selected = [] } return }
            this.busy = true; this.progress = 0
            try {
                g.styleStats_compute((list, info) => {
                    if (this._dead) return
                    this._raw = list
                    this.info = info || { rows: 0, cols: 0 }
                    this.decorate(list)
                    this.selected = g.styleFilter_keys()
                    this.busy = false
                }, (i, n) => { this.progress = n ? Math.round(i * 100 / n) : 100 })
            } catch (e) { this.busy = false }
        },
        decorate(list) {
            const g = this.grid
            let ruleMap = new Map()
            try { ruleMap = g?.styleRules_map?.() || ruleMap } catch (e) { /* без правил */ }
            this.rows = list.map(st => {
                const inline = st.key.startsWith('inline:')
                const info = inline ? null : this.store.cssClass_info(st.key)
                return {
                    ...st,
                    name: inline ? '' : st.key,
                    title: info?.title || (inline ? st.key.slice(7) : st.key),
                    group: inline ? 'Unnamed (inline style)' : (info?.group || 'Other classes'),
                    recordId: info && info.title !== info.id ? info.id : '',
                    css: g ? g.styleSample_css(st.key) : '',
                    rules: [...(ruleMap.get(st.key) || [])],
                    filterable: (st.rows || 0) > 0,
                }
            })
        },
        toggle(it, ev) {
            const g = this.grid
            if (!g || !it.filterable) return
            g.styleFilter_toggle(it.key, !!ev?.altKey)
            this.$nextTick(() => { this.selected = g.styleFilter_keys() })
        },
        clearFilter() {
            const g = this.grid
            if (!g) return
            g.styleFilter_set([])
            this.$nextTick(() => { this.selected = g.styleFilter_keys() })
        },
        // открыть элемент стиля (запись сегмента CSS-CLASS) — как любую ссылку
        openStyle(it) {
            try { this.store.executeStoreMethod(this, { command: 'widget_open', item: { id: it.recordId, segment: 'CSS-CLASS' } }) } catch (e) { /* без открытия */ }
        },
        // перейти на вкладку данных: панель вкладок — ближайший предок с tabPanel и вкладкой грида
        showGrid() {
            const g = this.grid
            if (!g) return
            try {
                let n = g.$parent
                while (n && !(n.tabPanel && typeof n.tabFind === 'function')) n = n.$parent
                // панель верхнего уровня: вкладка с самим гридом
                let top = this.$parent
                while (top && !(top.tabPanel && typeof top.tabFind === 'function')) top = top.$parent
                const panel = top || n
                const idx = panel ? (panel.tabFind('tabSheet') ?? -1) : -1
                if (panel && idx >= 0) panel.tabPanel.selectedIndex = idx
            } catch (e) { /* остаёмся на вкладке */ }
        },
    },
}
</script>

<style>
.attr-style-stats { display: flex; flex-direction: column; min-height: 120px; height: 100%; font-size: 12.25px; color: #3b444c; }
.attr-style-stats .ass-bar { display: flex; align-items: center; gap: 6px; padding: 6px 8px; border-bottom: 1px solid rgba(0, 0, 0, .08); flex-wrap: wrap; }
.attr-style-stats .ass-btn { display: inline-flex; align-items: center; gap: 5px; padding: 3px 9px; border: 1px solid rgba(0, 0, 0, .14); border-radius: 5px; background: #fff; color: inherit; font: inherit; cursor: pointer; }
.attr-style-stats .ass-btn:hover:not(:disabled) { background: #f1f4f7; }
.attr-style-stats .ass-btn:disabled { opacity: .45; cursor: default; }
.attr-style-stats .ass-btn .pi { font-size: 11px; }
.attr-style-stats .ass-info { margin-left: 6px; color: #74808a; }
.attr-style-stats .ass-empty { padding: 18px 12px; color: #74808a; }
.attr-style-stats .ass-scroll { overflow: auto; flex: 1 1 auto; }
.attr-style-stats .ass-table { border-collapse: collapse; width: 100%; max-width: 1180px; }
.attr-style-stats .ass-table th { position: sticky; top: 0; z-index: 1; background: #a3b6be; color: #fff; font-weight: 400; text-align: left; padding: 3px 8px; white-space: nowrap; }
.attr-style-stats .ass-table td { padding: 3px 8px; border-bottom: 1px solid rgba(0, 0, 0, .07); white-space: nowrap; }
.attr-style-stats .ass-c-num { text-align: right !important; font-variant-numeric: tabular-nums; width: 84px; }
.attr-style-stats .ass-c-check { width: 26px; }
.attr-style-stats .ass-c-sample { width: 84px; }
.attr-style-stats .ass-c-title { width: auto; white-space: normal !important; }
.attr-style-stats .ass-c-rules { max-width: 320px; overflow: hidden; text-overflow: ellipsis; color: #74808a; }
.attr-style-stats .ass-rules-n { display: inline-block; min-width: 16px; margin-right: 6px; padding: 0 4px; border-radius: 8px; background: #e6eaee; color: #4b5761; font-size: 11px; text-align: center; }
.attr-style-stats .ass-group td { background: #eef1f4; color: #5a6670; font-weight: 600; padding-top: 5px; padding-bottom: 5px; }
.attr-style-stats .ass-group-n { margin-left: 8px; font-weight: 400; color: #8a959e; }
.attr-style-stats .ass-row { cursor: pointer; }
.attr-style-stats .ass-row:hover td { background: rgba(0, 0, 0, .035); }
.attr-style-stats .ass-row.is-on td { background: rgba(255, 190, 60, .16); }
.attr-style-stats .ass-row.is-static { cursor: default; }
.attr-style-stats .ass-check { display: inline-flex; align-items: center; justify-content: center; width: 15px; height: 15px; border: 1px solid #9aa6b0; border-radius: 3px; background: #fff; vertical-align: -3px; }
.attr-style-stats .ass-check.is-on { background: #4a7ab5; border-color: #4a7ab5; color: #fff; }
.attr-style-stats .ass-check.is-off { opacity: .3; }
.attr-style-stats .ass-check .pi { font-size: 9px; font-weight: 700; }
.attr-style-stats .ass-sample { display: inline-block; min-width: 64px; padding: 1px 6px; border: 1px solid rgba(0, 0, 0, .08); box-sizing: border-box; text-align: center; background-color: #fff; }
.attr-style-stats .ass-title { color: #2f3840; }
.attr-style-stats .ass-name { margin-left: 8px; color: #8a959e; font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-size: 11px; }
.attr-style-stats .ass-open { margin-left: 8px; font-size: 10px; color: #8a959e; cursor: pointer; }
.attr-style-stats .ass-open:hover { color: #2f6fb5; }
.attr-style-stats .ass-rowlevel { margin-left: 6px; color: #8a959e; font-size: 11px; }
/* отбор по стилям: ячейки данных без отобранных стилей приглушены (AttrGrid.styleFilter_paint) */
.wj-flexgrid .wj-cell.style-filter-dim { opacity: .3; }
</style>
